import { EnvironmentProviders, InjectionToken, Provider } from '@angular/core';
import { ANALYTICS_ADAPTER } from './analytics.adapter';
import { MixpanelAnalyticsAdapter } from './mixpanel-analytics.adapter';
import { AnalyticsConfig } from './analytics.types';

const DEFAULT_ANALYTICS_CONFIG: Required<Pick<AnalyticsConfig, 'enabled'>> = {
  enabled: false,
};

const ANALYTICS_CONFIG = new InjectionToken<AnalyticsConfig>(
  'ANALYTICS_CONFIG',
  {
    providedIn: 'root',
    factory: () => DEFAULT_ANALYTICS_CONFIG,
  },
);

export function provideAnalytics(
  config: AnalyticsConfig = {},
): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: ANALYTICS_CONFIG,
      useValue: {
        ...DEFAULT_ANALYTICS_CONFIG,
        ...config,
      },
    },
    {
      provide: ANALYTICS_ADAPTER,
      useFactory: (analyticsConfig: AnalyticsConfig) =>
        new MixpanelAnalyticsAdapter(analyticsConfig),
      deps: [ANALYTICS_CONFIG],
    },
  ];
}
